// Словник марок і популярних моделей легкових авто для розумного пошуку
// та наповнення ads.make/ads.model у скрейпері. Канонічне ім'я = як воно
// має виглядати у фільтрі «Марка» (латиницею, як у власному каталозі з
// Ai-Business). Аліаси покривають UA/RU/трансліт написання, сленг
// («копейка», W124, е39) і часті одрукви; порівнюються після normalizeText
// (нижній регістр, ё→е, ї→і, пробіли згорнуті). Якщо точний збіг не
// знайдено, detectMakeModel пробує нечіткий (Левенштейн) по словнику.
import { normalizeText } from './stem.js';
export const makes = [
    { name: 'Acura', aliases: ['акура'] },
    { name: 'Alfa Romeo', aliases: ['альфа ромео', 'alfa romeo', 'альфа'] },
    { name: 'Audi', aliases: ['ауді', 'ауди', 'ауд'] },
    { name: 'BMW', aliases: ['бмв', 'бімер', 'бимер', 'бумер'] },
    { name: 'BYD', aliases: ['бід', 'бид'], origin: 'CN' },
    { name: 'Bogdan', aliases: ['богдан'] },
    { name: 'Brilliance', aliases: ['бриліанс', 'брілліанс', 'бріліанс'], origin: 'CN' },
    { name: 'Buick', aliases: ['буік', 'бьюик'] },
    { name: 'Cadillac', aliases: ['каділлак', 'кадиллак'] },
    { name: 'Changan', aliases: ['чанган', 'чанґан'], origin: 'CN' },
    { name: 'Chery', aliases: ['чері', 'черри', 'черрі'], origin: 'CN' },
    { name: 'Chevrolet', aliases: ['шевроле', 'шевр', 'шеврале', 'шевролле'] },
    { name: 'Chrysler', aliases: ['крайслер'] },
    { name: 'Citroen', aliases: ['сітроен', 'ситроен', 'цитроен'] },
    { name: 'Dacia', aliases: ['дачія', 'дачіа', 'дачия'] },
    { name: 'Daewoo', aliases: ['деу', 'дэу'] },
    { name: 'Daihatsu', aliases: ['дайхацу', 'дайхатсу'] },
    { name: 'Datsun', aliases: ['датсун'] },
    { name: 'Dodge', aliases: ['додж'] },
    { name: 'Dongfeng', aliases: ['донфенг', 'дунфен', 'дунфенг'], origin: 'CN' },
    { name: 'Exeed', aliases: ['ексід', 'ексид'], origin: 'CN' },
    { name: 'FAW', aliases: ['фау'], origin: 'CN' },
    { name: 'Fiat', aliases: ['фіат', 'фиат'] },
    { name: 'Ford', aliases: ['форд'] },
    { name: 'Foton', aliases: ['фотон', 'футон'], origin: 'CN' },
    { name: 'GAC', aliases: ['гак'], origin: 'CN' },
    { name: 'GAZ', aliases: ['газ', 'gaz'] },
    { name: 'Geely', aliases: ['гілі', 'джилі', 'джілі', 'гіллі'], origin: 'CN' },
    { name: 'GMC', aliases: ['джіемсі'] },
    { name: 'Great Wall', aliases: ['грейт вол', 'грэйт вол', 'грейтвол', 'грэйтвол'], origin: 'CN' },
    { name: 'Haval', aliases: ['хавал', 'хавейл'], origin: 'CN' },
    { name: 'Honda', aliases: ['хонда'] },
    { name: 'Hongqi', aliases: ['хонгчі', 'хунці', 'хунчи', 'хончи'], origin: 'CN' },
    { name: 'Hummer', aliases: ['хаммер', 'хамер'] },
    { name: 'Hyundai', aliases: ['хюндай', 'хендай', 'хундай', 'хендаї'] },
    { name: 'Infiniti', aliases: ['інфініті', 'инфинити'] },
    { name: 'Isuzu', aliases: ['ісузу', 'исузу'] },
    { name: 'IZH', aliases: ['іж', 'иж'] },
    { name: 'JAC', aliases: ['джак'], origin: 'CN' },
    { name: 'Jaecoo', aliases: ['джеку', 'джейку'], origin: 'CN' },
    { name: 'Jaguar', aliases: ['ягуар'] },
    { name: 'Jeep', aliases: ['джип'] },
    { name: 'Jetour', aliases: ['джетаур', 'джетур'], origin: 'CN' },
    { name: 'Kaiyi', aliases: ['кайї', 'кайи'], origin: 'CN' },
    { name: 'Kia', aliases: ['кіа', 'киа'] },
    { name: 'Lada', aliases: ['лада', 'ваз', 'vaz', 'жигулі', 'жигули'] },
    { name: 'Lancia', aliases: ['ланчіа', 'ланча'] },
    { name: 'Land Rover', aliases: ['ленд ровер', 'лендровер'] },
    { name: 'Lexus', aliases: ['лексус'] },
    { name: 'Lifan', aliases: ['ліфан', 'лифан'], origin: 'CN' },
    { name: 'Lixiang', aliases: ['лі сян', 'ли сян', 'li auto', 'лі авто', 'ли авто'], origin: 'CN' },
    { name: 'LuAZ', aliases: ['луаз'] },
    { name: 'Mazda', aliases: ['мазда'] },
    // 'mercedes' окреме слово: у заголовках OLX/RIA марка частиво латиницею
    // без «benz» («Mercedes Sprinter», «Mercedes W212») — канонік 'mercedes-benz'
    // одиничним токеном не накривається
    { name: 'Mercedes-Benz', aliases: ['мерседес', 'мерс', 'мерседес бенз', 'mercedes benz', 'mercedes', 'мерсідес', 'мерседес бенц', 'мерин'] },
    { name: 'MG', aliases: ['мг'], origin: 'CN' },
    { name: 'Mini', aliases: ['міні', 'мини'] },
    { name: 'Mitsubishi', aliases: ['міцубісі', 'мітсубіші', 'митсубиси', 'мицубиши'] },
    { name: 'Moskvich', aliases: ['москвич', 'москвіч', 'азлк', 'azlk'] },
    { name: 'NIO', aliases: ['ніо', 'нио'], origin: 'CN' },
    { name: 'Nissan', aliases: ['ниссан', 'ніссан', 'нісан', 'нисан'] },
    { name: 'Omoda', aliases: ['омода'], origin: 'CN' },
    { name: 'Opel', aliases: ['опель'] },
    { name: 'Peugeot', aliases: ['пежо'] },
    { name: 'Porsche', aliases: ['порше'] },
    { name: 'Ravon', aliases: ['равон'] },
    { name: 'Renault', aliases: ['рено', 'ренаулт'] },
    { name: 'Rover', aliases: ['ровер'] },
    { name: 'Saab', aliases: ['сааб'] },
    { name: 'Seat', aliases: ['сеат'] },
    { name: 'Skoda', aliases: ['шкода', 'шкодa', 'шкoда', 'shkoda'] },
    { name: 'Smart', aliases: ['смарт'] },
    { name: 'SsangYong', aliases: ['санг йонг', 'ссангйонг', 'санг енг', 'ссанг енг'] },
    { name: 'Subaru', aliases: ['субару'] },
    { name: 'Suzuki', aliases: ['сузукі', 'сузуки'] },
    { name: 'Tank', aliases: ['танк'], origin: 'CN' },
    { name: 'Tesla', aliases: ['тесла'] },
    { name: 'Toyota', aliases: ['тойота', 'тоета', 'тойета', 'тойота'] },
    { name: 'Volkswagen', aliases: ['фольксваген', 'вольксваген', 'фольц', 'фолцваген', 'vw'] },
    { name: 'Volvo', aliases: ['вольво', 'волво'] },
    { name: 'Voyah', aliases: ['войях', 'воях', 'войя'], origin: 'CN' },
    { name: 'Wey', aliases: ['вей'], origin: 'CN' },
    { name: 'Xpeng', aliases: ['ікспенг', 'икспенг'], origin: 'CN' },
    { name: 'ZAZ', aliases: ['заз'] },
    { name: 'Zeekr', aliases: ['зікр', 'зикр', 'зеекр'], origin: 'CN' },
    { name: 'УАЗ', aliases: ['уаз', 'uaz'] },
];
export const models = [
    // Nissan
    { make: 'Nissan', name: 'Leaf', aliases: ['лиф', 'ліф'], ev: true },
    { make: 'Nissan', name: 'Qashqai', aliases: ['кашкай', 'кашкаї'] },
    { make: 'Nissan', name: 'X-Trail', aliases: ['ікс трейл', 'х трейл', 'икс трейл'] },
    { make: 'Nissan', name: 'Almera', aliases: ['альмера'] },
    { make: 'Nissan', name: 'Primera', aliases: ['примьера', 'премьера', 'прімера'] },
    { make: 'Nissan', name: 'Patrol', aliases: ['патрол', 'патрик'] },
    { make: 'Nissan', name: 'Tiida', aliases: ['тііда', 'тида'] },
    { make: 'Nissan', name: 'Micra', aliases: ['мікра', 'микра'] },
    { make: 'Nissan', name: 'Navara', aliases: ['навара'] },
    { make: 'Nissan', name: 'Terrano', aliases: ['террано'] },
    { make: 'Nissan', name: 'Silvia', aliases: ['сильвія', 'сильвия'] },
    { make: 'Nissan', name: 'Skyline', aliases: ['скайлайн'] },
    { make: 'Nissan', name: 'Sunny', aliases: ['санні', 'санни'] },
    { make: 'Nissan', name: 'Laurel', aliases: ['лаурел'] },
    { make: 'Nissan', name: 'Cefiro', aliases: ['цефіро', 'цефиро'] },
    { make: 'Nissan', name: 'Maxima', aliases: ['максима'] },
    { make: 'Nissan', name: 'Pathfinder', aliases: ['пасфайндер'] },
    { make: 'Nissan', name: 'Juke', aliases: ['джук'] },
    { make: 'Nissan', name: 'Note', aliases: ['нот'] },
    { make: 'Nissan', name: 'Murano', aliases: ['мурано'] },
    // Toyota
    { make: 'Toyota', name: 'Camry', aliases: ['камрі', 'камри'] },
    { make: 'Toyota', name: 'Corolla', aliases: ['корола', 'королла', 'корол'] },
    { make: 'Toyota', name: 'Avensis', aliases: ['авенсіс', 'авенсис'] },
    { make: 'Toyota', name: 'RAV4', aliases: ['рав4', 'рав 4', 'rav 4'] },
    { make: 'Toyota', name: 'Land Cruiser', aliases: ['ланд крузер', 'крузак', 'круізер'] },
    { make: 'Toyota', name: 'Prado', aliases: ['прадо', 'прадик', 'прадік'] },
    { make: 'Toyota', name: 'Prius', aliases: ['пріус', 'приус'] },
    { make: 'Toyota', name: 'Yaris', aliases: ['яріс', 'ярис'] },
    { make: 'Toyota', name: 'Auris', aliases: ['ауріс', 'аурис'] },
    { make: 'Toyota', name: 'Hilux', aliases: ['хайлюкс', 'хілюкс'] },
    { make: 'Toyota', name: 'Highlander', aliases: ['хайлендер'] },
    { make: 'Toyota', name: 'Celica', aliases: ['целіка', 'целика'] },
    { make: 'Toyota', name: 'Mark II', aliases: ['марк 2', 'марк2', 'марк'] },
    { make: 'Toyota', name: 'Chaser', aliases: ['чазер', 'чейзер'] },
    { make: 'Toyota', name: 'Cresta', aliases: ['креста'] },
    { make: 'Toyota', name: 'Crown', aliases: ['кроун', 'краун'] },
    { make: 'Toyota', name: 'Surf', aliases: ['сурф', 'серф'] },
    { make: 'Toyota', name: 'Carina', aliases: ['карина'] },
    { make: 'Toyota', name: 'Corona', aliases: ['корона'] },
    { make: 'Toyota', name: 'Caldina', aliases: ['кальдина'] },
    { make: 'Toyota', name: 'Starlet', aliases: ['старлет'] },
    { make: 'Toyota', name: 'Probox', aliases: ['пробокс'] },
    { make: 'Toyota', name: 'Succeed', aliases: ['саксес'] },
    { make: 'Toyota', name: 'Hiace', aliases: ['хайс', 'хайес', 'хаєс'] },
    { make: 'Toyota', name: 'Aristo', aliases: ['аристо'] },
    // Volkswagen
    { make: 'Volkswagen', name: 'Passat', aliases: ['пасат', 'пассат', 'б3', 'б4', 'б5', 'б6', 'б7', 'б8', 'b3', 'b4', 'b5', 'b6', 'b7', 'b8'] },
    { make: 'Volkswagen', name: 'Golf', aliases: ['гольф', 'голф'] },
    { make: 'Volkswagen', name: 'Jetta', aliases: ['джетта'] },
    { make: 'Volkswagen', name: 'Tiguan', aliases: ['тігван', 'тигуан', 'тігуан'] },
    { make: 'Volkswagen', name: 'Polo', aliases: ['поло'] },
    { make: 'Volkswagen', name: 'Touareg', aliases: ['туарег'] },
    { make: 'Volkswagen', name: 'Touran', aliases: ['туран'] },
    { make: 'Volkswagen', name: 'Caddy', aliases: ['каді', 'кадди'] },
    { make: 'Volkswagen', name: 'Transporter', aliases: ['транспортер', 'т4', 'т5', 'т6', 't4', 't5', 't6', 'тачер', 'та4ер', 'кастен'] },
    { make: 'Volkswagen', name: 'Crafter', aliases: ['крафтер'] },
    { make: 'Volkswagen', name: 'Sharan', aliases: ['шаран'] },
    { make: 'Volkswagen', name: 'Bora', aliases: ['бора'] },
    { make: 'Volkswagen', name: 'ID.3', aliases: ['ід 3', 'ід3'], ev: true },
    { make: 'Volkswagen', name: 'ID.4', aliases: ['ід 4', 'ід4'], ev: true },
    { make: 'Volkswagen', name: 'e-Golf', aliases: ['е гольф', 'егольф'], ev: true },
    // Skoda
    { make: 'Skoda', name: 'Octavia', aliases: ['октавія', 'октавиа', 'октав'] },
    { make: 'Skoda', name: 'Fabia', aliases: ['фабія', 'фабиа'] },
    { make: 'Skoda', name: 'Superb', aliases: ['суперб'] },
    { make: 'Skoda', name: 'Rapid', aliases: ['рапід', 'рапид'] },
    { make: 'Skoda', name: 'Yeti', aliases: ['єті', 'ети'] },
    { make: 'Skoda', name: 'Kodiaq', aliases: ['кодіак', 'кодьяк'] },
    { make: 'Skoda', name: 'Enyaq', aliases: ['еньяк', 'енак'], ev: true },
    { make: 'Skoda', name: 'Felicia', aliases: ['феліція', 'фелиция'] },
    // Renault / Dacia
    { make: 'Renault', name: 'Logan', aliases: ['логан'] },
    { make: 'Renault', name: 'Sandero', aliases: ['сандеро'] },
    { make: 'Renault', name: 'Duster', aliases: ['дастер'] },
    { make: 'Renault', name: 'Megane', aliases: ['меган'] },
    { make: 'Renault', name: 'Scenic', aliases: ['сценік', 'сценик'] },
    { make: 'Renault', name: 'Clio', aliases: ['кліо', 'клио'] },
    { make: 'Renault', name: 'Kangoo', aliases: ['кангу'] },
    { make: 'Renault', name: 'Symbol', aliases: ['сімбол', 'симбол'] },
    { make: 'Renault', name: 'Laguna', aliases: ['лагуна'] },
    { make: 'Renault', name: 'Fluence', aliases: ['флюенс'] },
    { make: 'Renault', name: 'Captur', aliases: ['каптур'] },
    { make: 'Renault', name: 'Zoe', aliases: ['зоя'], ev: true },
    { make: 'Renault', name: 'Trafic', aliases: ['трафік', 'травік'] },
    { make: 'Renault', name: 'Master', aliases: ['мастер'] },
    // Opel
    { make: 'Opel', name: 'Astra', aliases: ['астра'] },
    { make: 'Opel', name: 'Vectra', aliases: ['вектра'] },
    { make: 'Opel', name: 'Corsa', aliases: ['корса'] },
    { make: 'Opel', name: 'Zafira', aliases: ['зафіра', 'зафира'] },
    { make: 'Opel', name: 'Insignia', aliases: ['інсігніа', 'инсигния'] },
    { make: 'Opel', name: 'Omega', aliases: ['омега'] },
    { make: 'Opel', name: 'Combo', aliases: ['комбо'] },
    { make: 'Opel', name: 'Vivaro', aliases: ['віваро', 'виваро'] },
    { make: 'Opel', name: 'Mokka', aliases: ['мокка'] },
    { make: 'Opel', name: 'Senator', aliases: ['сенатор'] },
    { make: 'Opel', name: 'Ascona', aliases: ['аскона'] },
    { make: 'Opel', name: 'Kadett', aliases: ['кадет'] },
    { make: 'Opel', name: 'Frontera', aliases: ['фронтера'] },
    { make: 'Opel', name: 'Meriva', aliases: ['мерива'] },
    // Ford
    { make: 'Ford', name: 'Focus', aliases: ['фокус'] },
    { make: 'Ford', name: 'Mondeo', aliases: ['мондэо', 'мондео'] },
    { make: 'Ford', name: 'Fiesta', aliases: ['фіеста', 'фиеста'] },
    { make: 'Ford', name: 'Fusion', aliases: ['фьюжн'] },
    { make: 'Ford', name: 'Transit', aliases: ['транзит'] },
    { make: 'Ford', name: 'Kuga', aliases: ['куга'] },
    { make: 'Ford', name: 'Explorer', aliases: ['експлорер'] },
    { make: 'Ford', name: 'Escort', aliases: ['ескорт'] },
    { make: 'Ford', name: 'Ranger', aliases: ['рейнджер'] },
    // Peugeot / Citroen
    { make: 'Peugeot', name: 'Partner', aliases: ['партнер', 'партнёр'] },
    { make: 'Peugeot', name: 'Boxer', aliases: ['боксер'] },
    { make: 'Peugeot', name: '206', aliases: [] },
    { make: 'Peugeot', name: '207', aliases: [] },
    { make: 'Peugeot', name: '307', aliases: [] },
    { make: 'Peugeot', name: '308', aliases: [] },
    { make: 'Peugeot', name: '406', aliases: [] },
    { make: 'Peugeot', name: 'Expert', aliases: ['експерт'] },
    { make: 'Citroen', name: 'Berlingo', aliases: ['берлінго', 'берлинго'] },
    { make: 'Citroen', name: 'Jumper', aliases: ['джампер'] },
    { make: 'Citroen', name: 'C-Crosser', aliases: ['с кроссер'] },
    { make: 'Citroen', name: 'C3', aliases: ['с3'] },
    { make: 'Citroen', name: 'C4', aliases: ['с4'] },
    { make: 'Citroen', name: 'C5', aliases: ['с5'] },
    { make: 'Citroen', name: 'Jumpy', aliases: ['джампі', 'джампи'] },
    { make: 'Citroen', name: 'Xantia', aliases: ['ксантія', 'ксантия'] },
    // Hyundai / Kia
    { make: 'Hyundai', name: 'Accent', aliases: ['акцент'] },
    { make: 'Hyundai', name: 'Elantra', aliases: ['елантра'] },
    { make: 'Hyundai', name: 'Sonata', aliases: ['соната'] },
    { make: 'Hyundai', name: 'Tucson', aliases: ['тусан', 'туксон', 'тюссан'] },
    { make: 'Hyundai', name: 'Santa Fe', aliases: ['санта фе'] },
    { make: 'Hyundai', name: 'Getz', aliases: ['гетц'] },
    { make: 'Hyundai', name: 'Solaris', aliases: ['соларіс', 'солярис'] },
    { make: 'Hyundai', name: 'i30', aliases: ['і30'] },
    { make: 'Hyundai', name: 'Porter', aliases: ['портер'] },
    { make: 'Hyundai', name: 'Starex', aliases: ['старекс'] },
    { make: 'Hyundai', name: 'Ioniq 5', aliases: ['іонік 5', 'іонік'], ev: true },
    { make: 'Hyundai', name: 'Ioniq 6', aliases: ['іонік 6'], ev: true },
    { make: 'Hyundai', name: 'Kona EV', aliases: ['кона ев'], ev: true },
    { make: 'Kia', name: 'Rio', aliases: ['ріо', 'рио'] },
    { make: 'Kia', name: 'Ceed', aliases: ['сід', 'сид', 'ceed'] },
    { make: 'Kia', name: 'Sportage', aliases: ['спортейдж', 'спортедж'] },
    { make: 'Kia', name: 'Sorento', aliases: ['соренто'] },
    { make: 'Kia', name: 'Cerato', aliases: ['церато'] },
    { make: 'Kia', name: 'Optima', aliases: ['оптіма', 'оптима'] },
    { make: 'Kia', name: 'Picanto', aliases: ['піканто'] },
    { make: 'Kia', name: 'Soul', aliases: ['соул'] },
    { make: 'Kia', name: 'Sephia', aliases: ['сефія', 'сефия'] },
    { make: 'Kia', name: 'Shuma', aliases: ['шума'] },
    { make: 'Kia', name: 'Carnival', aliases: ['карнівал'] },
    { make: 'Kia', name: 'Mohave', aliases: ['мохаве'] },
    { make: 'Kia', name: 'Seltos', aliases: ['селтос'] },
    { make: 'Kia', name: 'EV6', aliases: ['ев6'], ev: true },
    { make: 'Kia', name: 'e-Niro', aliases: ['е ніро', 'еніро'], ev: true },
    { make: 'Kia', name: 'Soul EV', aliases: ['соул ев'], ev: true },
    // Chevrolet / Daewoo / ZAZ
    { make: 'Chevrolet', name: 'Lacetti', aliases: ['лачетті', 'лачетти'] },
    { make: 'Chevrolet', name: 'Aveo', aliases: ['авео'] },
    { make: 'Chevrolet', name: 'Cruze', aliases: ['круз'] },
    { make: 'Chevrolet', name: 'Spark', aliases: ['спарк'] },
    { make: 'Chevrolet', name: 'Epica', aliases: ['епіка', 'эпика'] },
    { make: 'Chevrolet', name: 'Tahoe', aliases: ['тахо'] },
    // «болт» не додаємо як аліас: звичайне слово «болт» у заголовках запчастин
    { make: 'Chevrolet', name: 'Bolt', aliases: [], ev: true },
    { make: 'Chevrolet', name: 'Niva', aliases: ['шеви нива', 'шевинива'] },
    { make: 'Daewoo', name: 'Lanos', aliases: ['ланос'] },
    { make: 'Daewoo', name: 'Sens', aliases: ['сенс'] },
    { make: 'Daewoo', name: 'Nexia', aliases: ['нексія', 'нексия'] },
    { make: 'Daewoo', name: 'Matiz', aliases: ['матіз', 'матиз'] },
    { make: 'Daewoo', name: 'Nubira', aliases: ['нубіра', 'нубира'] },
    { make: 'Daewoo', name: 'Espero', aliases: ['ісперо', 'эсперо'] },
    { make: 'ZAZ', name: 'Tavria', aliases: ['таврія', 'таврия'] },
    { make: 'ZAZ', name: 'Slavuta', aliases: ['славута'] },
    { make: 'ZAZ', name: 'Forza', aliases: ['форца'] },
    // Honda / Mazda / Mitsubishi / Subaru / Suzuki
    { make: 'Honda', name: 'Civic', aliases: ['цівік', 'сівік', 'цивик'] },
    { make: 'Honda', name: 'Accord', aliases: ['акорд'] },
    { make: 'Honda', name: 'CR-V', aliases: ['срв', 'cr v', 'ср в'] },
    { make: 'Honda', name: 'Jazz', aliases: ['джаз'] },
    { make: 'Honda', name: 'Fit', aliases: ['фіт'] },
    { make: 'Honda', name: 'Stream', aliases: ['стрім'] },
    { make: 'Mazda', name: 'CX-5', aliases: ['сх5', 'сх 5', 'cx 5'] },
    { make: 'Mazda', name: 'CX-7', aliases: ['сх7', 'сх 7', 'cx 7'] },
    { make: 'Mazda', name: 'Demio', aliases: ['деміо'] },
    { make: 'Mazda', name: 'Premacy', aliases: ['премасі', 'премэси'] },
    { make: 'Mazda', name: 'Familia', aliases: ['фаміліа', 'фамилиа'] },
    { make: 'Mazda', name: 'Capella', aliases: ['капелла', 'капела'] },
    { make: 'Mazda', name: '323', aliases: [] },
    { make: 'Mazda', name: '626', aliases: [] },
    { make: 'Mazda', name: 'Tribute', aliases: ['трибют', 'трибьюте'] },
    { make: 'Mitsubishi', name: 'Lancer', aliases: ['лансер', 'ланцер'] },
    { make: 'Mitsubishi', name: 'Outlander', aliases: ['аутлендер', 'оутлендер'] },
    { make: 'Mitsubishi', name: 'Pajero', aliases: ['паджеро', 'паджерик'] },
    { make: 'Mitsubishi', name: 'ASX', aliases: ['асх'] },
    { make: 'Mitsubishi', name: 'Galant', aliases: ['галант'] },
    { make: 'Mitsubishi', name: 'Space Star', aliases: ['спейс стар'] },
    { make: 'Mitsubishi', name: 'L200', aliases: ['л200', 'л 200'] },
    { make: 'Mitsubishi', name: 'Carisma', aliases: ['каризма'] },
    { make: 'Mitsubishi', name: 'Colt', aliases: ['кольт'] },
    { make: 'Subaru', name: 'Forester', aliases: ['форестер', 'форик', 'форік'] },
    { make: 'Subaru', name: 'Impreza', aliases: ['імпреза', 'импреза'] },
    { make: 'Subaru', name: 'Legacy', aliases: ['легасі', 'легэси'] },
    { make: 'Subaru', name: 'Outback', aliases: ['аутбек'] },
    { make: 'Suzuki', name: 'Vitara', aliases: ['вітара', 'витара'] },
    { make: 'Suzuki', name: 'Swift', aliases: ['свифт', 'свіфт'] },
    { make: 'Suzuki', name: 'SX4', aliases: ['сх4', 'sx 4'] },
    { make: 'Suzuki', name: 'Jimny', aliases: ['джімні', 'джимни'] },
    // Mercedes / BMW / Audi. Кузовні індекси W### — канонічні імена (стиль
    // словника: W124 окремо від E-Class), голі числа — аліаси; короткі ключі,
    // зайняті іншими марками ('206' → Peugeot), без числового аліаса.
    { make: 'Mercedes-Benz', name: 'Sprinter', aliases: ['спринтер', 'w906', '906', 'w907'] },
    { make: 'Mercedes-Benz', name: 'Vito', aliases: ['віто', 'вито', 'w638', 'w639', 'w447'] },
    { make: 'Mercedes-Benz', name: 'Viano', aliases: ['віано', 'виано'] },
    { make: 'Mercedes-Benz', name: 'V-Class', aliases: ['в клас', 'v клас'] },
    { make: 'Mercedes-Benz', name: 'W123', aliases: [] },
    { make: 'Mercedes-Benz', name: 'W124', aliases: ['124', 'ешка'] },
    { make: 'Mercedes-Benz', name: 'W126', aliases: ['126'] },
    { make: 'Mercedes-Benz', name: 'W140', aliases: ['140', 'кабан'] },
    // ML/GLE: W163–W167 («ML163 164 166 GLE166 GLE167» — реальний заголовок)
    { make: 'Mercedes-Benz', name: 'W163', aliases: ['163', 'ml163'] },
    { make: 'Mercedes-Benz', name: 'W164', aliases: ['164', 'ml164'] },
    { make: 'Mercedes-Benz', name: 'W166', aliases: ['166', 'ml166', 'gle166'] },
    { make: 'Mercedes-Benz', name: 'W167', aliases: ['167', 'ml167', 'gle167'] },
    // A/B-клас: W168–W177, W245–W247
    { make: 'Mercedes-Benz', name: 'W168', aliases: ['168'] },
    { make: 'Mercedes-Benz', name: 'W169', aliases: ['169'] },
    { make: 'Mercedes-Benz', name: 'W176', aliases: ['176'] },
    { make: 'Mercedes-Benz', name: 'W177', aliases: ['177'] },
    { make: 'Mercedes-Benz', name: 'W245', aliases: [] },
    { make: 'Mercedes-Benz', name: 'W246', aliases: ['246'] },
    { make: 'Mercedes-Benz', name: 'W247', aliases: ['247'] },
    { make: 'Mercedes-Benz', name: 'W201', aliases: ['190'] },
    { make: 'Mercedes-Benz', name: 'W202', aliases: ['202'] },
    { make: 'Mercedes-Benz', name: 'W203', aliases: ['203'] },
    { make: 'Mercedes-Benz', name: 'W204', aliases: ['204'] },
    // '205'/'245' без w — НЕ аліаси: це ширина шин («205/55 R16», «245/40 R19»)
    { make: 'Mercedes-Benz', name: 'W205', aliases: [] },
    { make: 'Mercedes-Benz', name: 'W206', aliases: [] },
    { make: 'Mercedes-Benz', name: 'W210', aliases: [] },
    { make: 'Mercedes-Benz', name: 'W211', aliases: ['211'] },
    { make: 'Mercedes-Benz', name: 'W212', aliases: ['212'] },
    { make: 'Mercedes-Benz', name: 'W213', aliases: ['213'] },
    { make: 'Mercedes-Benz', name: 'W214', aliases: [] },
    { make: 'Mercedes-Benz', name: 'W220', aliases: ['220'] },
    { make: 'Mercedes-Benz', name: 'W221', aliases: ['221'] },
    { make: 'Mercedes-Benz', name: 'W222', aliases: ['222'] },
    { make: 'Mercedes-Benz', name: 'W223', aliases: ['223'] },
    { make: 'Mercedes-Benz', name: 'G-Class', aliases: ['гелік', 'гелик', 'гелендваген', 'геленваген', 'кубик', 'gelendwagen', 'gelik', 'w463'] },
    { make: 'Mercedes-Benz', name: 'A-Class', aliases: ['a клас', 'а клас'] },
    { make: 'Mercedes-Benz', name: 'B-Class', aliases: ['b клас', 'б клас'] },
    { make: 'Mercedes-Benz', name: 'C-Class', aliases: ['с клас', 'ц клас'] },
    { make: 'Mercedes-Benz', name: 'E-Class', aliases: ['е клас', 'є клас'] },
    { make: 'Mercedes-Benz', name: 'S-Class', aliases: ['ес клас', 's клас'] },
    { make: 'Mercedes-Benz', name: 'M-Class', aliases: ['мл', 'м клас'] },
    // SUV: GLK/GLA/GLC/GLE/GLS (ринкові назви; X###/C### — коди кузовів)
    { make: 'Mercedes-Benz', name: 'GLK', aliases: ['глк', 'x204'] },
    { make: 'Mercedes-Benz', name: 'GLA', aliases: ['гла', 'x156'] },
    { make: 'Mercedes-Benz', name: 'GLC', aliases: ['глц', 'x253', 'c253'] },
    { make: 'Mercedes-Benz', name: 'GLE', aliases: ['gle coupe', 'c292'] },
    { make: 'Mercedes-Benz', name: 'GLS', aliases: ['глс', 'x166', 'x167'] },
    // Купе-класи
    { make: 'Mercedes-Benz', name: 'CLA', aliases: ['кла', 'c117', 'x117', 'c118'] },
    { make: 'Mercedes-Benz', name: 'CLS', aliases: ['клс', 'c219', 'c218', 'c257'] },
    // Електричні: EQ-лінійка (EQA H243, EQB X243/W243, EQC N293,
    // EQE V295/W295 + SUV X294, EQS V297 + SUV X296)
    { make: 'Mercedes-Benz', name: 'EQA', aliases: ['h243'], ev: true },
    { make: 'Mercedes-Benz', name: 'EQB', aliases: ['x243', 'w243', 'екюбе'], ev: true },
    { make: 'Mercedes-Benz', name: 'EQC', aliases: ['n293'], ev: true },
    { make: 'Mercedes-Benz', name: 'EQE', aliases: ['v295', 'w295', 'x294', 'eqe suv', 'еке'], ev: true },
    { make: 'Mercedes-Benz', name: 'EQS', aliases: ['v297', 'x296'], ev: true },
    { make: 'BMW', name: 'E30', aliases: ['е30'] },
    { make: 'BMW', name: 'E34', aliases: ['е34'] },
    { make: 'BMW', name: 'E36', aliases: ['е36'] },
    { make: 'BMW', name: 'E38', aliases: ['е38'] },
    { make: 'BMW', name: 'E39', aliases: ['е39'] },
    { make: 'BMW', name: 'E46', aliases: ['е46'] },
    { make: 'BMW', name: 'E53', aliases: ['е53'] },
    { make: 'BMW', name: 'E60', aliases: ['е60'] },
    { make: 'BMW', name: 'E65', aliases: ['е65'] },
    { make: 'BMW', name: 'E70', aliases: ['е70'] },
    { make: 'BMW', name: 'E83', aliases: ['е83'] },
    { make: 'BMW', name: 'E90', aliases: ['е90'] },
    { make: 'BMW', name: 'E92', aliases: ['е92'] },
    { make: 'BMW', name: 'F10', aliases: ['ф10'] },
    { make: 'BMW', name: 'F30', aliases: ['ф30'] },
    { make: 'BMW', name: '3 Series', aliases: ['3 серия', 'трешка'] },
    { make: 'BMW', name: '5 Series', aliases: ['5 серия'] },
    { make: 'BMW', name: '7 Series', aliases: ['7 серия'] },
    { make: 'BMW', name: 'X5', aliases: ['х5', 'х 5'] },
    { make: 'BMW', name: 'X3', aliases: ['х3', 'х 3'] },
    { make: 'Audi', name: '80', aliases: [] },
    { make: 'Audi', name: '100', aliases: ['сотка'] },
    { make: 'Audi', name: '200', aliases: [] },
    { make: 'Audi', name: 'A3', aliases: ['а3'] },
    { make: 'Audi', name: 'A4', aliases: ['а4'] },
    { make: 'Audi', name: 'A5', aliases: ['а5'] },
    { make: 'Audi', name: 'A6', aliases: ['а6'] },
    { make: 'Audi', name: 'A8', aliases: ['а8'] },
    { make: 'Audi', name: 'Q7', aliases: ['ку7'] },
    { make: 'Audi', name: 'Q5', aliases: ['ку5'] },
    { make: 'Audi', name: 'TT', aliases: ['тт'] },
    // Land Rover / Jeep
    { make: 'Land Rover', name: 'Range Rover', aliases: ['рейндж ровер', 'рейндж'] },
    { make: 'Land Rover', name: 'Discovery', aliases: ['дискавері', 'дискавери'] },
    { make: 'Land Rover', name: 'Defender', aliases: ['дефендер'] },
    { make: 'Land Rover', name: 'Freelander', aliases: ['фрілендер', 'фриландер'] },
    { make: 'Jeep', name: 'Grand Cherokee', aliases: ['гранд черокі', 'гранд чероки'] },
    { make: 'Jeep', name: 'Wrangler', aliases: ['ренглер', 'ранглер'] },
    // Fiat
    { make: 'Fiat', name: 'Doblo', aliases: ['добло'] },
    { make: 'Fiat', name: 'Ducato', aliases: ['дукато'] },
    { make: 'Fiat', name: 'Scudo', aliases: ['скудо'] },
    { make: 'Fiat', name: 'Fiorino', aliases: ['фіоріно', 'фиорино'] },
    { make: 'Fiat', name: 'Panda', aliases: ['панда'] },
    { make: 'Fiat', name: 'Punto', aliases: ['пунто'] },
    { make: 'Fiat', name: 'Albea', aliases: ['альбеа'] },
    // SsangYong
    { make: 'SsangYong', name: 'Actyon', aliases: ['актйон', 'актион', 'актіон'] },
    { make: 'SsangYong', name: 'Korando', aliases: ['корандо'] },
    { make: 'SsangYong', name: 'Rexton', aliases: ['рекстон'] },
    { make: 'SsangYong', name: 'Kyron', aliases: ['кирон'] },
    { make: 'SsangYong', name: 'Tivoli', aliases: ['тіволі', 'тиволи'] },
    // Китайські
    { make: 'Great Wall', name: 'Hover', aliases: ['ховер'] },
    { make: 'Great Wall', name: 'Wingle', aliases: ['вінгл', 'вингл'] },
    { make: 'Great Wall', name: 'Safe', aliases: ['сейф'] },
    { make: 'Great Wall', name: 'Deer', aliases: ['дір', 'дир'] },
    { make: 'Chery', name: 'Tiggo', aliases: ['тігго', 'тигго'] },
    { make: 'Chery', name: 'Amulet', aliases: ['амулет'] },
    { make: 'Chery', name: 'Arrizo', aliases: ['арізо', 'арризо'] },
    { make: 'Geely', name: 'Coolray', aliases: ['кулрей', 'кулерей'] },
    { make: 'Geely', name: 'Emgrand', aliases: ['емгранд'] },
    { make: 'Geely', name: 'MK', aliases: ['мк'] },
    { make: 'Geely', name: 'Atlas', aliases: ['атлас'] },
    { make: 'Haval', name: 'H6', aliases: ['н6', 'х6', 'h 6'] },
    { make: 'Haval', name: 'Jolion', aliases: ['джоліон', 'джолион'] },
    { make: 'Haval', name: 'Dargo', aliases: ['дарго'] },
    { make: 'Exeed', name: 'TXL', aliases: [] },
    { make: 'Jetour', name: 'X70', aliases: ['х70'] },
    { make: 'Jetour', name: 'X90', aliases: ['х90'] },
    { make: 'Jetour', name: 'Dashing', aliases: ['дашинг'] },
    { make: 'Tank', name: '300', aliases: ['танк 300'] },
    { make: 'Tank', name: '500', aliases: ['танк 500'] },
    { make: 'Kaiyi', name: 'E5', aliases: ['е5'] },
    { make: 'Omoda', name: 'C5', aliases: ['с5'], contextual: true },
    // Китайські електромобілі. Omoda C5 — contextual: голий ключ 'c5' зайнятий
    // Citroen C5 (канонічні імена перезаписуються в modelIndex), тому Omoda C5
    // розпізнається лише парою «omoda c5»/«омода с5». В Україні C5 продається
    // і з ДВЗ — без прапорця ev.
    { make: 'BYD', name: 'Song Plus', aliases: ['сонг плюс', 'сонг'], ev: true },
    { make: 'BYD', name: 'Seal', aliases: [], ev: true },
    { make: 'BYD', name: 'Han', aliases: ['хан'], ev: true },
    { make: 'BYD', name: 'Atto 3', aliases: ['атто 3', 'ато 3'], ev: true },
    { make: 'BYD', name: 'Dolphin', aliases: ['дельфін', 'дельфин'], ev: true },
    { make: 'Zeekr', name: '001', aliases: [], ev: true },
    { make: 'Zeekr', name: '007', aliases: [], ev: true },
    { make: 'Zeekr', name: '009', aliases: [], ev: true },
    { make: 'Lixiang', name: 'L7', aliases: ['л7'], ev: true },
    { make: 'Lixiang', name: 'L8', aliases: ['л8'], ev: true },
    { make: 'Lixiang', name: 'L9', aliases: ['л9'], ev: true },
    { make: 'Jaecoo', name: 'J7', aliases: [], ev: true },
    { make: 'Jaecoo', name: 'J8', aliases: [], ev: true },
    { make: 'MG', name: 'ZS EV', aliases: ['зс ев'], ev: true },
    { make: 'MG', name: 'MG4', aliases: ['мг4', 'мг 4'], ev: true },
    { make: 'Ravon', name: 'Gentra', aliases: ['джентра'] },
    // Вітчизняні
    { make: 'Lada', name: 'Vesta', aliases: ['веста'] },
    { make: 'Lada', name: 'Granta', aliases: ['гранта'] },
    { make: 'Lada', name: 'Kalina', aliases: ['каліна', 'калина'] },
    { make: 'Lada', name: 'Priora', aliases: ['приора'] },
    { make: 'Lada', name: 'Largus', aliases: ['ларгус'] },
    { make: 'Lada', name: 'Niva', aliases: ['ніва', 'нива'] },
    { make: 'Lada', name: 'Samara', aliases: ['самара'] },
    { make: 'Lada', name: '2101', aliases: ['копейка', 'копєйка'] },
    { make: 'Lada', name: '2103', aliases: [] },
    { make: 'Lada', name: '2105', aliases: ['пятерка', 'пятёрка'] },
    { make: 'Lada', name: '2106', aliases: ['шестерка', 'шестёрка'] },
    { make: 'Lada', name: '2107', aliases: ['семерка', 'семёрка'] },
    { make: 'Lada', name: '2108', aliases: ['восьмерка', 'восьмёрка', 'зубило'] },
    { make: 'Lada', name: '2109', aliases: ['девятка', 'девятка'] },
    { make: 'Lada', name: '21099', aliases: [] },
    { make: 'Lada', name: '2110', aliases: ['десятка'] },
    { make: 'Lada', name: '2112', aliases: ['двенашка'] },
    { make: 'Lada', name: '2114', aliases: [] },
    { make: 'Lada', name: 'Oka', aliases: ['ока'] },
    { make: 'Lada', name: 'Classic', aliases: ['классика', 'класика'] },
    { make: 'GAZ', name: 'Gazelle', aliases: ['газель', 'газелька'] },
    { make: 'GAZ', name: 'Sobol', aliases: ['соболь'] },
    { make: 'GAZ', name: 'Volga', aliases: ['волга'] },
    { make: 'УАЗ', name: 'Patriot', aliases: ['патріот', 'патриот'] },
    { make: 'УАЗ', name: 'Hunter', aliases: ['хантер'] },
    { make: 'УАЗ', name: '452', aliases: ['буханка', 'таблетка', 'головастик'] },
    { make: 'Moskvich', name: '412', aliases: [] },
    { make: 'Moskvich', name: '2141', aliases: ['святогор'] },
    { make: 'LuAZ', name: '969', aliases: ['луноход', 'волинь', 'волынь'] },
    { make: 'IZH', name: 'Oda', aliases: ['ода'] },
    // Volvo / Saab
    { make: 'Volvo', name: 'XC60', aliases: ['кс60', 'xc 60'] },
    { make: 'Volvo', name: 'XC90', aliases: ['кс90', 'xc 90'] },
    { make: 'Volvo', name: 'S60', aliases: ['ес60', 's 60'] },
    { make: 'Volvo', name: 'S80', aliases: ['ес80', 's 80'] },
    // Tesla
    { make: 'Tesla', name: 'Model 3', aliases: ['модель 3', 'модел 3'], ev: true },
    { make: 'Tesla', name: 'Model S', aliases: ['модель с', 'модел с'], ev: true },
    { make: 'Tesla', name: 'Model X', aliases: ['модель х', 'модел х'], ev: true },
    { make: 'Tesla', name: 'Model Y', aliases: ['модель у', 'модел у'], ev: true },
];
/** alias (нормалізований) → марка, включно з канонічним ім'ям */
const makeIndex = new Map();
/** alias (нормалізований) → модель, включно з канонічним ім'ям */
const modelIndex = new Map();
for (const make of makes) {
    makeIndex.set(normalizeText(make.name), make);
    for (const alias of make.aliases) {
        const key = normalizeText(alias);
        if (!makeIndex.has(key))
            makeIndex.set(key, make);
    }
}
for (const model of models) {
    // контекстні моделі не займають загальні ключі: 'c5' лишається за Citroen C5
    if (model.contextual)
        continue;
    modelIndex.set(normalizeText(model.name), model);
    for (const alias of model.aliases) {
        const key = normalizeText(alias);
        if (!modelIndex.has(key))
            modelIndex.set(key, model);
    }
}
/** «марка модель» → пара: контекстні ключі для моделей із зайнятим коротким
 *  ключем — «omoda c5»/«омода с5» → Omoda C5 (проти citroen c5). */
const contextualModelIndex = new Map();
for (const model of models) {
    if (!model.contextual)
        continue;
    const makeDef = makeIndex.get(normalizeText(model.make));
    if (!makeDef)
        continue;
    const makeKeys = [normalizeText(makeDef.name), ...makeDef.aliases.map((a) => normalizeText(a))];
    const modelKeys = [normalizeText(model.name), ...model.aliases.map((a) => normalizeText(a))];
    for (const mk of makeKeys) {
        for (const mdl of modelKeys)
            contextualModelIndex.set(`${mk} ${mdl}`, { make: makeDef, model });
    }
}
/** Нормалізовані імена китайських марок — фокус-режим «китайські авто». */
export const CHINESE_MAKE_NAMES = new Set(makes.filter((m) => m.origin === 'CN').map((m) => normalizeText(m.name)));
/** Нормалізована марка → назви й аліаси суто електричних моделей. */
export const EV_MODELS_BY_MAKE = (() => {
    const map = new Map();
    for (const model of models) {
        if (!model.ev)
            continue;
        const key = normalizeText(model.make);
        let names = map.get(key);
        if (!names) {
            names = new Set();
            map.set(key, names);
        }
        names.add(normalizeText(model.name));
        for (const alias of model.aliases)
            names.add(normalizeText(alias));
    }
    return map;
})();
export function findMakeByName(name) {
    return makeIndex.get(normalizeText(name));
}
export function findModelByName(name) {
    return modelIndex.get(normalizeText(name));
}
/** Усі написання марки для пошуку в тексті: канонічне + аліаси. */
export function makeAliases(name) {
    const make = findMakeByName(name);
    if (!make)
        return [normalizeText(name)];
    return [normalizeText(make.name), ...make.aliases.map((a) => normalizeText(a))];
}
/** Усі написання моделі для пошуку в тексті: канонічне + аліаси. */
export function modelAliases(make, name) {
    const model = modelIndex.get(normalizeText(name));
    if (!model || normalizeText(model.make) !== normalizeText(make)) {
        return [normalizeText(name)];
    }
    return [normalizeText(model.name), ...model.aliases.map((a) => normalizeText(a))];
}
// --- Нечіткий збіг (одрукви) -----------------------------------------------
// Точний збіг по вікнах не спрацював — пробуємо одиночні токени проти
// словника з відстанню Левенштейна ≤1 (для слів ≥8 символів ≤2). Ловиться
// і одрук («шеврале»), і відмінок («мерседеса»). Ключі коротші за 5
// символів, багатослівні та «співзвучні зі звичайними словами» (сотка,
// панда, атлас…) у нечіткому пошуку не беруться — лише точний збіг.
const FUZZY_MIN_LEN = 5;
const FUZZY_DENY = new Set([
    'сотка', 'таблетка', 'головастик', 'стрім', 'атлас', 'панда', 'мастер',
    'соул', 'куга', 'джаз', 'серф', 'танк', 'волинь', 'копейка', 'гранта',
]);
function withinEditDistance(a, b, maxDist) {
    if (Math.abs(a.length - b.length) > maxDist)
        return false;
    let prev = new Array(b.length + 1);
    let cur = new Array(b.length + 1);
    for (let j = 0; j <= b.length; j++)
        prev[j] = j;
    for (let i = 1; i <= a.length; i++) {
        cur[0] = i;
        let rowMin = cur[0];
        for (let j = 1; j <= b.length; j++) {
            const cost = a.charCodeAt(i - 1) === b.charCodeAt(j - 1) ? 0 : 1;
            cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
            if (cur[j] < rowMin)
                rowMin = cur[j];
        }
        if (rowMin > maxDist)
            return false;
        const t = prev;
        prev = cur;
        cur = t;
    }
    return prev[b.length] <= maxDist;
}
function buildFuzzyKeys(index) {
    const out = [];
    for (const key of index.keys()) {
        if (key.length < FUZZY_MIN_LEN || key.includes(' '))
            continue;
        if (FUZZY_DENY.has(key))
            continue;
        out.push(key);
    }
    return out;
}
const makeFuzzyKeys = buildFuzzyKeys(makeIndex);
const modelFuzzyKeys = buildFuzzyKeys(modelIndex);
function fuzzyHit(token, keys) {
    const maxDist = token.length >= 8 ? 2 : 1;
    for (const key of keys) {
        if (withinEditDistance(token, key, maxDist))
            return key;
    }
    return undefined;
}
/**
 * Пошук марки й моделі в нормалізованому списку токенів (вікна 1–3 токени,
 * виграє найдовше совпадіння; далі — нечіткий фолбек для одруків). Якщо
 * модель знайдена, але її марка конфліктує з явною маркою запиту — модель
 * відкидається (токени лишаються вільними).
 */
export function detectMakeModel(tokens) {
    const makeIdx = [];
    const modelIdx = [];
    const consumed = new Set();
    let make;
    let model;
    for (let size = 3; size >= 1; size--) {
        for (let i = 0; i + size <= tokens.length; i++) {
            if (tokens.slice(i, i + size).some((_, k) => consumed.has(i + k)))
                continue;
            const key = tokens.slice(i, i + size).join(' ');
            // контекстна пара «марка модель» (omoda c5): ставить одразу обидва,
            // поки жоден не зайнятий — інакше 'omoda' з'ївся б маркою на кроці 1
            if (size >= 2 && !make && !model) {
                const ctx = contextualModelIndex.get(key);
                if (ctx) {
                    make = ctx.make;
                    model = ctx.model;
                    for (let k = i; k < i + size; k++) {
                        consumed.add(k);
                        makeIdx.push(k);
                        modelIdx.push(k);
                    }
                    continue;
                }
            }
            if (!make) {
                const hit = makeIndex.get(key);
                if (hit) {
                    make = hit;
                    for (let k = i; k < i + size; k++) {
                        consumed.add(k);
                        makeIdx.push(k);
                    }
                    continue;
                }
            }
            if (!model) {
                const hit = modelIndex.get(key);
                if (hit) {
                    model = hit;
                    for (let k = i; k < i + size; k++) {
                        consumed.add(k);
                        modelIdx.push(k);
                    }
                }
            }
        }
    }
    // Нечіткий фолбек: невжиті одиночні токени (≥5 символів) проти словника.
    if (!make || !model) {
        for (let i = 0; i < tokens.length; i++) {
            if (consumed.has(i))
                continue;
            const tok = tokens[i];
            if (tok.length < FUZZY_MIN_LEN)
                continue;
            if (!make) {
                const hit = fuzzyHit(tok, makeFuzzyKeys);
                if (hit) {
                    make = makeIndex.get(hit);
                    consumed.add(i);
                    makeIdx.push(i);
                    continue;
                }
            }
            if (!model) {
                const hit = fuzzyHit(tok, modelFuzzyKeys);
                if (hit) {
                    const candidate = modelIndex.get(hit);
                    if (candidate) {
                        model = candidate;
                        consumed.add(i);
                        modelIdx.push(i);
                    }
                }
            }
        }
    }
    if (model && make && normalizeText(model.make) !== normalizeText(make.name)) {
        model = undefined;
        for (const i of modelIdx)
            consumed.delete(i);
        modelIdx.length = 0;
    }
    return { make, model, makeIdx, modelIdx };
}
//# sourceMappingURL=makes.js.map